module.exports = __webpack_public_path__ + "static/media/gameColony.f9c0dfcc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameColony.png
// module id = 2277
// module chunks = 0